export default __webpack_public_path__ + "static/media/MUJER9.22a6536b.png";